module.exports = __webpack_public_path__ + "assets/img/right-arrow.d2f8ab19.svg";